import { render, staticRenderFns } from "./account-settings-email.vue?vue&type=template&id=4ae3c66f&scoped=true&"
import script from "./account-settings-email.vue?vue&type=script&lang=ts&"
export * from "./account-settings-email.vue?vue&type=script&lang=ts&"
import style0 from "./account-settings-email.vue?vue&type=style&index=0&id=4ae3c66f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae3c66f",
  null
  
)

export default component.exports